module.exports = __webpack_public_path__ + "img/DE06282.62cabd1e.png";